import React, { useEffect, useState, useMemo } from "react";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { modifyLocalForm } from "../../redux/actions-exporter";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
import ItemList from "../repeats/itemList/ItemList";
import PersonalDetails from "../repeats/personalDetails/PersonalDetails";
import {
  getProductsByCategoryId,
  getProductCategories,
} from "../../redux/API/productCategories/productCategories.action";

import bannerImg from "../../assets/images/TII/0d29cde6ea92435fc56819d5d1f3d55a.jpg";
import galleryImg1 from "../../assets/images/MT/6.jpg";
import galleryImg2 from "../../assets/images/MT/GettyImages-135385164_pczbmr.jpg";
import galleryImg3 from "../../assets/images/MT/moving-checklist-2000-6ec63f4c4aa94bf9b9cb32f80bfd97a7.jpg";
import galleryImg4 from "../../assets/images/MT/6-Common-Mistakes-to-Avoid-When-Hiring-a-Moving-Company.jpeg";
import galleryImg5 from "../../assets/images/MT/AdobeStock_300477109-min_a23ba322c2da1cd76ade9dd3d3983ed1_2000.jpeg";
import galleryImg6 from "../../assets/images/MT/movers-collegeville.jpg";
import logo from "../nav/Logo";

const TransportOnlineItems = ({ mainLogo }) => {
  const [validated, setValidated] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const BOXES_CATEGORY_ID = process.env.REACT_APP_BOXES_CATEGORY_ID;
  const DELIVERY_CATEGORY_ID = process.env.REACT_APP_DELIVERY_CATEGORY_ID;
  const SERVICES_CATEGORY_ID = process.env.REACT_APP_SERVICES_CATEGORY_ID;
  const form = useSelector((state) => state.form);
  const [state, setState] = useState(form);
  const [checked, setChecked] = useState(false);
  // const isSurcharge =
  //   form.extraFields?.fromunusualwalkway === "כן" ||
  //   form.extraFields?.tounusualwalkway === "כן";

  const [cart, setCart] = useState(form.cart ?? []);

  const [price, setPrice] = useState(0);
  const [servicesPrice, setServicesPrice] = useState(0);
  // const [surchargeFee, setSurchargeFee] = useState(0);
  // const [packagePrice, setPackagePrice] = useState(0);

  const products = useSelector(
    (state) => state.productCategories.productsCategoryById
  );
  const categories = useSelector((state) =>
    state.productCategories.productCategories.filter(
      (category) => category.parent === 1
    )
  );

  const isProductsCategoryPending = useSelector(
    (state) => state.productCategories.isProductsCategoryPending
  );

  const handleProducts = (newCart) => {
    const boxId = state.extraFields?.box;
    if (boxId) {
      const boxInCart = newCart.find(item => item.entityId === Number(boxId));
      if (boxInCart && boxInCart.entityId !== boxId) {
        setState({
          ...state,
          extraFields: {
            ...state.extraFields,
            box: boxInCart.entityId,
          },
        });
      }
      if (!boxInCart) {
        setState({
          ...state,
          extraFields: {
            ...state.extraFields,
            box: null,
          },
        });
      }
    }
    return setCart(newCart);
  };

  useEffect(() => {
    // let surcharge = 0.2;

    let cartPriceBeforeSurcharge = cart
      .filter((item) => item.entityId !== 277538)
      .reduce((total, item) => total + item.price * (item.number || 1), 0);

    setPrice(cartPriceBeforeSurcharge);

    setServicesPrice(
      cart.reduce(
        (total, item) =>
          total +
          ((item.h || item.p) && item.attributeValues
            ? (Number(
              (item.h ? Number(item.attributeValues.assemblePrice) : 0) +
              (item.p ? Number(item.attributeValues.disassemblePrice) : 0)
            ) || 0) * (Number(item.number) || 1)
            : 0),
        0
      )
    );
    // if (isSurcharge) {
    //   setSurchargeFee(surcharge * cartPriceBeforeSurcharge);
    // }
  }, [cart, state.extraFields]);

  // Adding surcharge fee to cart
  // useEffect(() => {
  //   if (surchargeFee > 0) {
  //     let surchargeFeeProduct = cart.find((item) => item.entityId === 277538);
  //     if (surchargeFeeProduct) {
  //       surchargeFeeProduct.price = surchargeFee;
  //     } else {
  //       let surchargeFeeProduct = products[SERVICES_CATEGORY_ID].find(
  //         (element) => element.entityId === 277538
  //       );

  //       setCart([...cart, { ...surchargeFeeProduct, price: surchargeFee }]);
  //     }
  //   }
  // }, [surchargeFee]);

  useEffect(() => {
    if (state.extraFields && state.extraFields["box"]) {
      const boxes = products[process.env.REACT_APP_BOXES_CATEGORY_ID];
      const boxIds = boxes.map((box) => box.entityId);

      let cartWithoutBoxes = cart.filter(
        (item) => !boxIds.includes(item.entityId)
      );
      let obj = boxes.find(
        (item) => item.entityId === Number(state.extraFields["box"])
      );

      setCart([...cartWithoutBoxes, obj]);
    }
    if (state.extraFields && state.extraFields["box"] === null) {
      const boxes = products[process.env.REACT_APP_BOXES_CATEGORY_ID];
      const boxIds = boxes.map((box) => box.entityId);

      let cartWithoutBoxes = cart.filter(
        (item) => !boxIds.includes(item.entityId)
      )

      setCart(cartWithoutBoxes);
    }
  }, [state.extraFields["box"], products]);

  useEffect(() => {
    if (!isProductsCategoryPending) {
      dispatch(getProductCategories());
      dispatch(getProductsByCategoryId(BOXES_CATEGORY_ID));
      dispatch(getProductsByCategoryId(DELIVERY_CATEGORY_ID));
      dispatch(getProductsByCategoryId(SERVICES_CATEGORY_ID));
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    if (cart && products[SERVICES_CATEGORY_ID]) {
      const deliveryProduct = cart.find(e => e.entityId === 277629);
      const { deliveryDistance } = form;
      if (deliveryProduct) {
        deliveryProduct.number = deliveryDistance;
      } else {
        const deliveryProduct = products[SERVICES_CATEGORY_ID].find(e => e.entityId === 277629);
        setCart([...cart, { ...deliveryProduct, number: deliveryDistance }])
      }
    }
  }, [cart, products]); // eslint-disable-line

  const [start, setStart] = useState(true);

  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView();
  //   setStart(false);
  // }, []);

  const onChange = (value) => {
    setState({
      ...state,
      ...value,
    });
    if (value.name) {
      setState({
        ...state,
        extraFields: {
          ...state.extraFields,
          name: value.name,
        },
      });
    }
  };

  const handleForward = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else if (!cart.length || (cart.length === 1 && cart[0].entityId === 277130)) {
      alert("נא לבחור לפחות פריט אחד");
      e.stopPropagation();
    } else {
      dispatch(
        modifyLocalForm({
          ...state,
          cart,
          price: price + servicesPrice, //+ surchargeFee,
          servicesPrice,
        })
      );
      navigate("/transportsummary");
    }
    setValidated(true);
  };
  const onChangeExtraField = (e) => {
    setState({
      ...state,
      extraFields: {
        ...state.extraFields,
        [e.target.name]: e.target.value,
      },
    });
  };

  const galleryArr = [
    {
      img: galleryImg1,
    },
    {
      img: galleryImg2,
    },
    {
      img: galleryImg3,
    },
    {
      img: galleryImg4,
    },
    {
      img: galleryImg5,
    },
    {
      img: galleryImg6,
    },
  ];

  return (
    <div className="transportFewItems">
      {/* {console.log(products[process.env.REACT_APP_BOXES_CATEGORY_ID])} */}
      {/* <div className="page_banner">
        <img src={bannerImg} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הזמנת הובלה אונליין</h1>
            <p>רק למלא פרטים ולשלוח</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/transportonlineaddress" />
            <MainBtn
              text="הזמנה בעזרת נציג"
              link="/transportgetback"
              isLight={true}
            />
          </div>
        </div>
      </div>
      <Pros /> */}
      <div className="servicesDiv">
        <h1 className="homeTitle">בחירת פריטים</h1>
        {Object.keys(state).length === 0
          ? navigate("/transportonlineaddress")
          : null}
        <div className="splitDiv">
          {/* <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="שירותי הובלות"
              galleryArr={galleryArr}
            />
          </div> */}

          <div className="formSide">
            <Form
              className="formBox"
              noValidate
              validated={validated}
              onSubmit={handleForward}
            >
              <ItemList
                products={products[DELIVERY_CATEGORY_ID] || []}
                cart={cart}
                categories={categories}
                handleProducts={handleProducts}
                onChange={onChangeExtraField}
                boxes={products[BOXES_CATEGORY_ID] || []}
                isServices={true}
              />

              <PersonalDetails onChange={onChange} values={state} />
              <Button
                style={{
                  background: "var(--primary)",
                  border: "none",
                  width: "100%",
                }}
                text=" קבלת הצעת מחיר"
                type="submit"
                className="filter-btn"
              >
                קבלת הצעת מחיר
              </Button>
            </Form>
          </div>
        </div>
      </div>
      {/* <Reviews />
      <Footer /> */}
    </div>
  );
};

export default TransportOnlineItems;
